(function (window, document, $) {
  'use strict';

  // define _wq to hook into wistia api
  // https://wistia.com/doc/player-api
  window._wq = window._wq || [];
  window._wq.push({
      id: '_all',
      onReady: function (video) {
        var id = video.hashedId();
        var $wistiaEl = $('.wistia_async_' + id);
        var $el = $wistiaEl.closest('[data-video-api="wistia"]');
        $el.data('wistiaId', id);

        if ($el.data('playOnReady')) {
          video.play();
        }
      }
  });

  // untabify/retabify are used to prevent tabable elements from getting focus when video modal is open
  var unTabify = function ($modalContainer) {
    var tabbableSelector, tabbable;
    tabbableSelector = 'a, :input:not(:disabled), area, [tabindex]';
    tabbable = $(tabbableSelector).not($modalContainer.find(tabbableSelector));
    tabbable.each(function () {
        var $this = $(this);
        $this.data('tabindexStore', $this.prop('tabindex')).prop('tabindex', -1);
    });
  };
  var reTabify = function ($modalContainer) {
    var tabbableSelector, tabbable;
    tabbableSelector = 'a, :input:not(:disabled), area, [tabindex]';
    tabbable = $(tabbableSelector).not($modalContainer.find(tabbableSelector));
    tabbable.each(function () {
        var $this = $(this);
        $this.prop('tabindex', $this.data('tabindexStore') || 0).removeData('tabindexStore');
    });
  };

  // three api's, SmartPlayer, Wistia, Youtube
  // returns object with play() and stop() methods that call the appropriate api
  // each play() method may be called before video is ready, so each handles that case
  var getVideoApi = function ($videoContent) {
    var api = $videoContent.data('video-api');
    return api === 'wistia' ? getWistiaPlayerApi($videoContent) :
      api === 'youtube' ? getYouTubePlayerApi($videoContent) :
      getSmartplayerApi($videoContent);
  };

  var getSmartplayerApi = function ($videoContent) {
    var frameQuery = function (selector) {
      var frame = $videoContent.find('iframe')[0];
      var frameDocument = frame && frame.contentDocument;
      return $(frameDocument).find(selector);
    };

    var timeoutRef;

    var api = {
      play: function () {
        window.clearTimeout(timeoutRef);
        var $clickToPlay = frameQuery('#videoClickToPlayLink, #videoClickToReplayLink').filter(':visible');
        if ($clickToPlay.length) {
          $clickToPlay[0].click();
          return;
        }

        var video = frameQuery('video')[0];
        if (video) {
          video.play();
          return;
        }

        timeoutRef = window.setTimeout(api.play, 100);
      },
      stop: function () {
        window.clearTimeout(timeoutRef);
        var video = frameQuery('video')[0];
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    };

    return api;    
  };

  var getWistiaPlayerApi = function ($videoContent) {
    return {
      play: function () {
        var wistiaId = $videoContent.data('wistiaId');
        var video = wistiaId ? window.Wistia && window.Wistia.api(wistiaId) : null;
        if (video) {
          video.play();
        } else {
          $videoContent.data('playOnReady', true);
        }
      },
      stop: function () {
        var wistiaId = $videoContent.data('wistiaId');
        $videoContent.removeData('playOnReady');
        var video = wistiaId ? window.Wistia && window.Wistia.api(wistiaId) : null;
        if (video) {
          video.pause();
          video.time(0);
        }
      }
    };
  };

  var getYouTubePlayerApi = function ($videoContent) {
    return {
      play: function () {
        var player = $videoContent.data('youtube-api');
        if (player) {
          player.playVideo();
        } else {
          $videoContent.data('playOnReady', true);
        }
      },
      stop: function () {
        $videoContent.removeData('playOnReady');
        var player = $videoContent.data('youtube-api');
        if (player) {
          player.pauseVideo();
          player.seekTo(0);
        }
      }
    };
  };

  // methods to generate dom elements for video
  var generateSmartplayerFrame = function (url) {
    var $videoPlayer = $('<div>', { 'class': 'video-player' });
    var $frame = $('<iframe>', {
      'class': 'tsc_player_inline smart-player-embed-container-iframe',
      src: url,
      scrolling: 'no',
      frameborder: 0,
      allowfullscreen: '',
      mozallowfullscreen: '',
      webkitallowfullscreen: ''
    });

    return $videoPlayer.append($frame);
  };

  var generateVideoModal = function ($videoContent, size) {
    var $modalContainer = $('<div>', { 'class': 'modal-container modal-inactive' });
    var $modalOverlay = $('<div>', { 'class': 'modal-overlay' });
    var $modalFixedPositioner = $('<div>', { 'class': 'modal-fixed-positioner' });
    var $modalVideoWidth = $('<div>', { 'class': 'modal-video-width' });
    var $close = $('<button>', { type: 'button', 'class': 'modal-video-close glyph glyph-close' });
    var $modalVideoRatio = $('<div>', { 'class': 'modal-video-ratio' });
    var $modalVideoWindow = $('<div>', { 'class': 'modal-video-window' });

    $modalContainer
      .append($modalOverlay)
      .append($modalFixedPositioner);

    $modalFixedPositioner
      .append($modalVideoWidth);

    $modalVideoWidth
      .addClass(size || '')
      .append($close)
      .append($modalVideoRatio);

    $modalVideoRatio
      .append($modalVideoWindow);

    $modalVideoWindow
      .append($videoContent);

    return $modalContainer;
  };

  var generateVideoReplacement = function ($videoContent, size) {
    var $replacementPlayer = $('<div>', { 'class': 'replacement-player replacement-uninitialized' });
    var $replacementPositioner = $('<div>', { 'class': 'replacement-positioner' });
    var $replacementRatio = $('<div>', { 'class': 'replacement-ratio' });
    var $replacementWindow = $('<div>', { 'class': 'replacement-window' });

    $replacementPlayer
      .addClass(size || '')
      .append($replacementPositioner);

    $replacementPositioner
      .append($replacementRatio);

    $replacementRatio
      .append($replacementWindow);

    $replacementWindow
      .append($videoContent);

    return $replacementPlayer;
  };

  var loadYouTubeApi = function ($youtubePlayers) {
    if (window.onYouTubeIframeAPIReady) {
      return;
    }

    window.onYouTubeIframeAPIReady = function () {
      $youtubePlayers.each(function (i, el) {
        var $el = $(el);
        var $contentHolder = $el.parent();
        var youtubeId = $el.data('youtube-id');
        var options = {
          videoId: youtubeId,
          events: {
            onReady: function (event) {
              $contentHolder.data('youtube-api', event.target);
              if ($contentHolder.data('playOnReady')) {
                event.target.playVideo();
              }
            },
            onStateChange: function (event) {
              if (event.data === window.YT.PlayerState.BUFFERING) {
                event.target.setPlaybackQuality('highres');
              }
            }
          }
        };
        return new window.YT.Player(el, options);
      });
    };

    // load the youtube api script https://developers.google.com/youtube/iframe_api_reference
    var ytApiTag = document.createElement('script');
    ytApiTag.src = 'https://www.youtube.com/iframe_api';
    var ytApiScriptTag = document.getElementsByTagName('script')[0];
    ytApiScriptTag.parentNode.insertBefore(ytApiTag, ytApiScriptTag);
  };

  var setupSmartplayerFullframeCallbacks = function () {
    if (!window.TSC || !window.TSC.fullFrameModeController) {
      return;
    }

    var fullFrameCallbackClosure = function (isFullFrame) {
      return function () {
        $('body').toggleClass('smart-player-full-frame' , isFullFrame);
        $('.modal-container.modal-active, .replacement-container.video-player-activated .replacement-player')
          .toggleClass('smart-player-full-frame-mode', isFullFrame);
      };
    };

    window.TSC.fullFrameModeController.setCustomEnterCallback(fullFrameCallbackClosure(true));
    window.TSC.fullFrameModeController.setCustomExitCallback(fullFrameCallbackClosure(false));
  };

  var onDocumentReady = function () {
    setupSmartplayerFullframeCallbacks();

    var $youtubePlayers = $('.youtube-player');
    if ($('.youtube-player').length) {
      loadYouTubeApi($youtubePlayers);
    }

    $('.modal-video-trigger').each(function (i, el) {
      var $trigger = $(el);
      var templateId = $trigger.data('video-template');
      var contentId = $trigger.data('video-content');
      var $videoContent;

      if (templateId) {
        var markup = $('#' + templateId).html();
        var $div = $('<div>').html(markup);
        $videoContent = $div.contents();
      } else if (contentId) {
        $videoContent = $('#' + contentId);
      } else {
        $videoContent = generateSmartplayerFrame($trigger.prop('href'));
      }

      var size =  $trigger.data('size') || 'video-max-800';
      var $modalContent = generateVideoModal($videoContent, size);

      $videoContent.removeClass('hide');

      $modalContent
        .appendTo('.slider')
        .addClass('modal-inactive')
        .on('click.modalplayer', '.modal-video-close, .modal-overlay', function (e) {
          var videoApi = getVideoApi($videoContent);
          e.preventDefault();
          reTabify($modalContent);
          videoApi.stop();
          $modalContent
            .removeClass('modal-active')
            .addClass('modal-inactive');
          $trigger.focus();
        });

      $trigger.on('click.modalplayer', function (e) {
        var videoApi = getVideoApi($videoContent);
        e.preventDefault();
        unTabify($modalContent);
        $modalContent
          .removeClass('modal-inactive')
          .addClass('modal-active');
        videoApi.play();
        $modalContent.find('iframe').focus();
      });
    });

    $('.replacement-video-trigger').each(function (i, el) {
      var $trigger = $(el);
      var $container = $trigger.closest('.replacement-container');
      var templateId = $trigger.data('video-template');
      var contentId = $trigger.data('video-content');
      var $videoContent;

      if (templateId) {
        var markup = $('#' + templateId).html();
        var $div = $('<div>').html(markup);
        $videoContent = $div.contents();
      } else if (contentId) {
        $videoContent = $('#' + contentId);
      } else {
        $videoContent = generateSmartplayerFrame($trigger.prop('href'));
      }

      var size =  $trigger.data('size') || 'video-max-1280';
      var $replacementContent = generateVideoReplacement($videoContent, size);

      $videoContent.removeClass('hide');

      $replacementContent
        .prependTo($container)
        .removeClass('replacement-uninitialized');

      $trigger.on('click.replacementplayer', function (e) {
        $container.addClass('video-player-activated');
        var videoApi = getVideoApi($videoContent);
        videoApi.play();
        e.preventDefault();
      });
    });
  };

  $(onDocumentReady);
}(window, document, jQuery));
